import { ListVesselsAndShuttles } from "~/components/admin/operations";
import PageMeta from "~/components/common/meta";

export const ScreenVessel = () => {
  return (
    <>
      <PageMeta title="Vessels | Art Handler" description="Vessels" />
      <ListVesselsAndShuttles />
    </>
  );
};
